import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { RootState } from '../redux/store';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = useSelector((s: RootState) => s.auth.token);
  const { practiceId } = useParams<{ practiceId: string }>();

  if (!token) {
    if (practiceId) {
      return <Navigate to={`/${practiceId}`} replace />;
    }
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};


